export default "__VITE_ASSET__CWeKPRif__"